<template>
  <OmtStickedModal v-if="isOpen" @close="close">
    <OmtIcons name="circle-exclamation" size="2x" color="var(--colors-light-support-warning)" mb="24px" />

    <OmtTypography as="h1-large" mb="24px"> Sua sessão expirou </OmtTypography>

    <CBox bg="#F6F6F9" borderRadius="8px" p="24px 16px" mb="24px">
      <CFlex alignItems="center" mb="16px">
        <OmtIcons name="mobile" size="lg"
mr="12px" />
        <OmtTypography as="h2-bold"> Faça login novamente </OmtTypography>
      </CFlex>

      <OmtTypography as="p1">
        Você ficou inativo por alguns minutos e, por segurança, sua sessão foi encerrada.
      </OmtTypography>
    </CBox>

    <template #footer>
      <OmtButton w="100%" @click="close">
        <OmtTypography as="h1-bold" color="white"> Concluir </OmtTypography>
      </OmtButton>
    </template>
  </OmtStickedModal>
</template>

<script>
/**
 * @prop {Boolean} isOpen
 */
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close() {
      this.$emit("update:isOpen", false);
    }
  }
};
</script>
